import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../Utils/AxiosInstance";
// import { Api } from "@mui/icons-material";

const initialState = {
  overview: null,
  leadsSummary: null,
  // inventorySummary: null,
  inventorySummary: {
    totalUnits: 0,
    availableUnits: 0,
    bookedUnits: 0,
    projectSummaries: [],
  },
  topAgents: [],
  highestCommissionEarned: [],
  activitiesSummary: null,
  pipelines: [],
  target: [],
  leadSourceAnalysis: null,
  loading: false,
  error: null,
};

export const fetchOverview = createAsyncThunk("dashboard/fetchOverview", async () => {
  const response = await axiosInstance.get("/dashbord/overview");
  return response.data;
});

export const fetchLeadsSummary = createAsyncThunk("dashboard/fetchLeadsSummary", async pipelineId => {
  const response = await axiosInstance.get("/dashbord/leadsSummaryByPipeline", {
    params: { pipelineId },
  });
  return response.data.leads;
});

export const fetchInventorySummary = createAsyncThunk("dashboard/fetchInventorySummary", async () => {
  const response = await axiosInstance.get("/dashbord/inventorySummary");
  return response.data;
});

export const fetchTopAgents = createAsyncThunk("dashboard/fetchTopAgents", async () => {
  const response = await axiosInstance.get("/dashbord/getTopAgents");
  return response.data;
});

export const fetchHighestCommissionEarned = createAsyncThunk("dashboard/fetchHighestCommissionEarned", async () => {
  const response = await axiosInstance.get("/dashbord/highestCommissionEarned");
  return response.data;
});

export const fetchActivitiesSummary = createAsyncThunk("dashboard/fetchActivitiesSummary", async () => {
  const response = await axiosInstance.get("/dashbord/activitiesSummary");

  return response.data;
});

export const fetchTarget = createAsyncThunk("dashboard/fetchTarget", async () => {
  const response = await axiosInstance.get("/dashbord/target");
  return response.data;
});

export const fetchLeadSourceAnalysis = createAsyncThunk("dashboard/fetchLeadSourceAnalysis", async () => {
  const response = await axiosInstance.get("/Dashbord/leadSourceAnalysis");
  return response.data;
});


const NewDashboardSlice = createSlice({
  name: "NewDashboard",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchOverview.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchOverview.fulfilled, (state, action) => {
      state.loading = false;
      state.overview = action.payload;
    });
    builder.addCase(fetchOverview.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(fetchLeadsSummary.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchLeadsSummary.fulfilled, (state, action) => {
      state.loading = false;
      state.leadsSummary = action.payload;
    });
    builder.addCase(fetchLeadsSummary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(fetchInventorySummary.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchInventorySummary.fulfilled, (state, action) => {
      state.loading = false;
      state.inventorySummary = action.payload;
    });
    builder.addCase(fetchInventorySummary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(fetchTopAgents.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchTopAgents.fulfilled, (state, action) => {
      state.loading = false;
      state.topAgents = action.payload;
    });
    builder.addCase(fetchTopAgents.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(fetchHighestCommissionEarned.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchHighestCommissionEarned.fulfilled, (state, action) => {
      state.loading = false;
      state.highestCommissionEarned = action.payload;
    });
    builder.addCase(fetchHighestCommissionEarned.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(fetchActivitiesSummary.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchActivitiesSummary.fulfilled, (state, action) => {
      state.loading = false;
      state.activitiesSummary = action.payload;
    });
    builder.addCase(fetchActivitiesSummary.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(fetchTarget.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchTarget.fulfilled, (state, action) => {
      state.loading = false;
      state.target = action.payload;
    });
    builder.addCase(fetchTarget.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(fetchLeadSourceAnalysis.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchLeadSourceAnalysis.fulfilled, (state, action) => {
      state.loading = false;
      state.leadSourceAnalysis = action.payload;
    });
    builder.addCase(fetchLeadSourceAnalysis.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

  },
});

export default NewDashboardSlice.reducer;
